<template>
  <div id="app">
	<router-view></router-view>
  </div>
</template>

<script>
	import axios from 'axios'
	import { mapActions } from 'vuex'
	export default {
		name: 'app',
		methods: {
			...mapActions(['recoverFromDixie']),
		},
		mounted(){
			this.recoverFromDixie()
				.then((a) => {
					this.$router.replace('/pay')
				})
				.catch((b) => {
					this.$router.replace('/not-found')
				})
		}
	}
</script>


<style lang="scss">

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #4c5d6e;
    margin: 3em 0em;
	padding: 0em;

    h1,
    h2 {
      font-weight: normal;
      top: 1em;
      position: relative;
    }

    ul {
      list-style-type: none;
      padding: 0;
    }

    li {
      display: inline-block;
      margin: 0 10px;
    }

    a {
      color: #86a31c;
    }

  }
</style>



// WEBPACK FOOTER //
// src/App.vue